import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '@shared/angular-material.module';
import { SharedModule } from '@shared/shared.module';
import { UserProfilePageComponent } from './components/user-profile-page/user-profile-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		UserProfilePageComponent
	],
	imports: [
		AngularMaterialModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		TranslateModule
	]
})
export class ProfileModule { }
